export default "__VITE_ASSET__m3hArWLU__"